import Input, { InputType } from "components/shared/inputs/input";
import { SvgAddNote, SvgCommandAdd, SvgCommandEdit, SvgSupprimer } from "components/svg";
import numeral from "numeral";
import { useEffect, useState } from "react";
import { useWatch, type Control } from "react-hook-form";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";


interface QuoteSectionProps {
    name: string;
    items: any[];
    deleteProduct?: (e: any, index: number) => void;
    addProduct?: (e: any) => void;
    getTotal: (items: any, applyVAT?: boolean) => void;
    showEco: boolean;
    onChange: (name: string, value: any, index: number, min?: number, max?: number) => void;
    filter: string;
    comment?: string | null | undefined;
    openCommentPopup?: () => void;
    control: Control<any>;
}

const QuoteSection: React.FC<QuoteSectionProps> = ({
    name,
    items,
    deleteProduct,
    addProduct,
    getTotal,
    showEco,
    onChange,
    filter,
    comment,
    openCommentPopup,
    control,

}) => {
    const { t } = useTranslation();
    const { network, isThermor } = useSalesNetwork();
    const [itemsList, setItemsList] = useState<any[]>([])

    useEffect(() => {
        const _items = items.filter((item: any) => item._type === filter && item._selected);
        setItemsList(_items);
    }, [items, filter])

    return (
        <>


            <group>
                <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20">
                    <group data-length="autofit">
                        <text data-text-size="x-large" data-wrap="wrap">{name}</text>
                    </group>
                </group>


                <group
                    data-direction="column"
                    data-gap="20">

                    {items?.map((item: any, index: number) => { //NOSONAR
                        if (item._type !== filter) return;
                        if (deleteProduct && (!item._selected && !item._recommended)) return;

                        return (
                            <group
                                //key={generateKey()}
                                key={"lines_" + index}
                                {...(isThermor ? { "data-border-color": "main-color-custom-border" } : { "data-color": "main-light" })}
                                data-border="inheret">

                                <group data-direction="column"
                                    data-adaptive="desktop-1000"
                                    data-contain=""
                                    data-background="white">
                                    <group data-space="20"
                                        data-gap="20"
                                        data-wrap="no">
                                        <group data-ratio="1:1"
                                            data-shrink="no"
                                            data-length="120"
                                            data-radius="5">
                                            {(item.photo || item._accessory?.photo) ? <picture>
                                                <img alt="" src={item.photo || item._accessory?.photo} />
                                            </picture> : <group data-background="main-color-custom-lighter"></group>
                                            }
                                        </group>

                                        <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-length="50">{t("ARTICLE_CODE")}</text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-mid" data-width="auto" data-align="center" >
                                                {item.id ? <text data-text-size="large" data-wrap="wrap">{item.code_env}</text> :
                                                    <Input
                                                        type={InputType.Text}
                                                        name={"lines[" + index + "].code_env"}
                                                        control={control}
                                                        size="large"
                                                        onChange={(e) => {
                                                            onChange("code_env", e.target.value, index)
                                                            //e.preventDefault();
                                                        }}
                                                    />}
                                            </group>
                                        </group>

                                        <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-min-length="200">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-text-align="center">{t("DESC")}</text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                {item.id ? <text data-text-size="large" data-align="center" data-wrap="wrap">{item.reference}</text> :
                                                    <Input
                                                        type={InputType.Text}
                                                        name={"lines[" + index + "].reference"}
                                                        control={control}
                                                        size="large"
                                                        onChange={(e) => {
                                                            onChange("reference", e.target.value, index)
                                                            //e.preventDefault();
                                                        }}
                                                    />}
                                            </group>
                                        </group>

                                        <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-text-align="center">{t("QTY")}</text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center">
                                                <group data-align="center" data-width="auto">
                                                    <Input
                                                        type={InputType.Number}
                                                        name={"lines[" + index + "]._qty"}
                                                        control={control}
                                                        size="large"
                                                        minValue={0}
                                                        maxValue={9999999}
                                                        onChange={(e) => {
                                                            onChange("_qty", e, index, 0, 9999999)
                                                        }}
                                                    />
                                                </group>
                                            </group>
                                        </group>

                                        {!network?._parameters.hidePrice && <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-length="120" data-text-align="center">{t("RECOM_PUBLIC_PRICE", { currency: network?._parameters.currency })}</text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                {item.id ? <text data-text-size="large" data-wrap="wrap" data-length="100" data-text-align="center" data-width="auto">{numeral(item.price).format('0,0.00') + ' ' + network?._parameters.currency}</text> :
                                                    <Input
                                                        type={InputType.Number}
                                                        name={"lines[" + index + "].price"}
                                                        control={control}
                                                        size="large"
                                                        minValue={item._type === 'generator' ? 1 : 0}
                                                        maxValue={9999999}
                                                        onChange={(e) => {
                                                            onChange("price", e, index, 0, 9999999)
                                                        }}
                                                    />}
                                            </group>
                                        </group>}

                                        {!network?._parameters.hidePrice && <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-width="auto">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-length="100" data-text-align="center">{t("DISCOUNT")}</text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center">
                                                <group data-align="center" data-width="auto">
                                                    <Input
                                                        size="large"
                                                        type={InputType.Number}
                                                        name={"lines[" + index + "]._discount"}
                                                        control={control}
                                                        //value={item._discount}
                                                        minValue={0}
                                                        maxValue={100}
                                                        onChange={(e) => {
                                                            onChange("_discount", e, index, 0, 100)
                                                        }}
                                                    />
                                                </group>
                                            </group>
                                        </group>}

                                        {!network?._parameters.hidePrice && showEco && <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-width="auto">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-length="80" data-text-align="center">{t("ECO_PRICE", { currency: network?._parameters.currency })}</text>
                                            </group>
                                            <group data-height="autofit" data-min-height="60" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                {item.id ?
                                                    <text data-text-size="large"
                                                        data-wrap="wrap" data-length="100" data-text-align="center" data-width="auto">{numeral(item.eco).format('0,0.00') + ' ' + network?._parameters.currency}</text>
                                                    : <Input type={InputType.Number}
                                                        name={"lines[" + index + "].eco"}
                                                        control={control}
                                                        size="large"
                                                        minValue={0}
                                                        onChange={(e) => {
                                                            onChange("eco", e, index, 0)
                                                        }}
                                                    />}
                                            </group>
                                        </group>}

                                        {!network?._parameters.hidePrice && <group data-direction="column" data-wrap="no" data-gap="10" data-length="autofit" data-align="center" data-width="auto">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-length="100" data-text-align="center">{t("TOTAL_HT", { currency: network?._parameters.currency })}</text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-dark" data-align="center" data-width="auto">
                                                <text data-text-size="large" data-wrap="wrap" data-length="100" data-weight="600" data-text-align="center">{numeral(getTotal(item, false)).format('0,0.00')} {network?._parameters.currency}</text>
                                            </group>
                                        </group>}

                                        <group data-direction="column" data-wrap="no" data-gap="10" data-length="" data-align="center" data-width="auto">
                                            <group data-height="autofit" data-color="grey-color-mid" data-align="center" data-width="auto">
                                                <text data-text-size="14" data-wrap="wrap" data-text-align="center"></text>
                                            </group>
                                            <group data-height="autofit" data-color="grey-color-dark" data-align="center" data-width="auto">
                                                {
                                                    deleteProduct && !item._recommended ?
                                                        <div className="button mini" onClick={(e) => deleteProduct(e, index)}>
                                                            <icon data-svg-size="24"
                                                                {...(isThermor ? { "data-svg-color": "main" } : { "data-svg-color": "secondary" })}

                                                            ><SvgSupprimer /></icon>
                                                        </div>
                                                        :
                                                        <group data-length="40">

                                                        </group>
                                                }
                                            </group>
                                        </group>
                                    </group>
                                </group>

                                <group data-direction="column"
                                    data-adaptive="mobile-1000"
                                    data-contain=""
                                    data-background="white">


                                    {!item.id && <group data-space="20"
                                        data-gap="5"
                                        data-color="grey-color-mid"
                                        data-wrap="no"
                                    >
                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("DESC")}</text>
                                        </group>
                                        <group data-length="200" data-align="center">
                                            <group data-width="auto" data-position="right">
                                                <Input
                                                    type={InputType.Text}
                                                    name={"lines[" + index + "].reference"}
                                                    control={control}
                                                    size="large"
                                                    onChange={(e) => {
                                                        onChange("reference", e.target.value, index)
                                                        //e.preventDefault();
                                                    }}
                                                />
                                            </group>
                                        </group>
                                    </group>}

                                    {!item.id && <group data-space="20"
                                        data-gap="5"
                                        data-space-top="0"
                                        data-color="grey-color-mid"
                                    >
                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("ARTICLE_CODE")}</text>
                                        </group>
                                        <group data-length="120" data-align="center">
                                            <group data-width="auto" data-position="right">
                                                <Input
                                                    type={InputType.Text}
                                                    name={"lines[" + index + "].code_env"}
                                                    control={control}
                                                    dataLength="90"
                                                    size="large"
                                                    onChange={(e) => {
                                                        onChange("code_env", e.target.value, index)
                                                        //e.preventDefault();
                                                    }}
                                                />
                                            </group>
                                        </group>
                                    </group>}


                                    {item.id && <group data-space="20"
                                        data-space-bottom="0"
                                        data-gap="5"
                                        data-color="initial"
                                    >
                                        <group>

                                            <text data-text-size="large" data-weight="600" data-color="grey-color-dark" data-wrap="wrap">
                                                {item.reference}
                                            </text>
                                        </group>
                                        <group data-gap="10" data-text-size="medium">
                                            <text data-wrap="wrap">{t("ARTICLE_CODE")} :</text>
                                            <text>
                                                {item.code_env}
                                            </text>

                                        </group>
                                        <separator data-horizontal="" />
                                    </group>}

                                    <group data-space="20"
                                        data-space-top="0"
                                        // {...(item.id ? { "data-space-top": "0" } : {})}
                                        data-gap="5"
                                        data-color="grey-color-mid"
                                    >
                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("QTY")}</text>
                                        </group>
                                        <group data-length="120" data-align="center">
                                            <group data-width="auto" data-position="right">
                                                <Input
                                                    type={InputType.Number}
                                                    name={"lines[" + index + "]._qty"}
                                                    control={control}
                                                    size="large"
                                                    minValue={0}
                                                    maxValue={9999999}
                                                    dataLength="90"
                                                    onChange={(e) => {
                                                        onChange("_qty", e, index, 0, 9999999)
                                                    }}
                                                />
                                            </group>
                                        </group>
                                    </group>

                                    {!network?._parameters.hidePrice && <group data-space="20"
                                        data-space-top="0"
                                        data-gap="5"
                                        data-color="grey-color-mid"
                                    >

                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("RECOM_PUBLIC_PRICE", { currency: network?._parameters.currency })}</text>
                                        </group>

                                        <group data-length="120" data-align="center">
                                            <group data-width="auto" data-position="right">
                                                {item.id ? <text data-text-size="large" data-wrap="wrap" data-text-align="center" data-width="auto">{numeral(item.price).format('0,0.00') + ' ' + network?._parameters.currency}</text> :
                                                    <Input
                                                        type={InputType.Number}
                                                        name={"lines[" + index + "].price"}
                                                        control={control}
                                                        size="large"
                                                        minValue={item._type === 'generator' ? 1 : 0}
                                                        maxValue={9999999}
                                                        dataLength="90"
                                                        onChange={(e) => {
                                                            onChange("price", e, index, 0, 9999999)
                                                        }}
                                                    />}
                                            </group>
                                        </group>
                                    </group>}

                                    {!network?._parameters.hidePrice && <group data-space="20"
                                        data-space-top="0"
                                        data-gap="5"
                                        data-color="grey-color-mid"
                                    >

                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("DISCOUNT")}</text>
                                        </group>

                                        <group data-length="120" data-align="center">
                                            <group data-width="auto" data-position="right">
                                                <Input
                                                    size="large"
                                                    type={InputType.Number}
                                                    name={"lines[" + index + "]._discount"}
                                                    control={control}
                                                    dataLength="90"
                                                    //value={item._discount}
                                                    minValue={0}
                                                    maxValue={100}
                                                    onChange={(e) => {
                                                        onChange("_discount", e, index, 0, 100)
                                                    }}
                                                />
                                            </group>
                                        </group>
                                    </group>}

                                    {!network?._parameters.hidePrice && <group data-space="20"
                                        data-space-top="0"
                                        data-gap="5"
                                        data-color="grey-color-mid"
                                    >

                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("ECO_PRICE", { currency: network?._parameters.currency })}</text>
                                        </group>

                                        <group data-length="120" data-align="center">
                                            <group data-width="auto" data-position="right">
                                                {item.id ?
                                                    <text data-text-size="large"
                                                        data-wrap="wrap" data-length="100" data-text-align="center" data-width="auto">{numeral(item.eco).format('0,0.00') + ' ' + network?._parameters.currency}</text>
                                                    : <Input type={InputType.Number}
                                                        name={"lines[" + index + "].eco"}
                                                        control={control}
                                                        size="large"
                                                        dataLength="90"
                                                        minValue={0}
                                                        onChange={(e) => {
                                                            onChange("eco", e, index, 0)
                                                        }}
                                                    />}
                                            </group>
                                        </group>
                                    </group>}

                                    {!network?._parameters.hidePrice && <group data-space="20"
                                        data-space-top="0"
                                        data-gap="5"
                                        data-color="grey-color-mid"
                                    >

                                        <group data-length="autofit" data-align="center">
                                            <text data-text-size="14" data-wrap="wrap">{t("TOTAL_HT", { currency: network?._parameters.currency })}</text>
                                        </group>

                                        <group data-length="120" data-align="center">
                                            <group data-width="auto" data-position="right" data-color="initial">
                                                <text data-text-size="large" data-wrap="wrap" data-length="100" data-weight="600" data-text-align="center">{numeral(getTotal(item, false)).format('0,0.00')} {network?._parameters.currency}</text>
                                            </group>
                                        </group>
                                    </group>}


                                    {!item.id && deleteProduct && !item._recommended && <group data-space="20"
                                        data-gap="5"
                                        data-space-top="0"
                                        data-color="grey-color-mid"
                                    >
                                        <separator data-horizontal="" />
                                        <group data-length="autofit" data-align="center">
                                            <div className="button mini" onClick={(e) => deleteProduct(e, index)}>
                                                <icon data-svg-size="24"
                                                    {...(isThermor ? { "data-svg-color": "main" } : { "data-svg-color": "secondary" })}
                                                ><SvgSupprimer /></icon>
                                            </div>
                                        </group>

                                    </group>}


                                </group>

                            </group>)
                    })}

                    {filter !== "accessories" &&

                        <group data-gap="20">
                            <group data-length="forcefit" data-fit="1" data-gap="20">
                            </group>
                            {!network?._parameters.hidePrice && <group dadata-length="forcefit" data-fit="1" data-gap="20" data-align="center">
                                <text data-text-size="large" data-fit="2" data-length="autofit" data-weight="300">{t('TOTAL_HT', { currency: network?._parameters.currency })}</text>
                                <text data-text-size="large" data-fit="1" data-length="autofit" data-text-align="center" data-weight="600">{numeral(getTotal(itemsList, false)).format('0,0.00')} {network?._parameters.currency}</text>
                                <space data-length="10"></space>
                            </group>}
                        </group>
                    }

                    {filter === "accessories" &&

                        <>
                            <group data-gap="20" data-adaptive="desktop">
                                <group data-length="forcefit" data-fit="1" data-gap="20">
                                    {addProduct && <div className="button large secondary outline" data-length="forcefit" onClick={addProduct}>
                                        <icon data-svg-size="20" data-svg-color="secondary"><SvgCommandAdd /></icon>
                                        <text data-width="auto">{t("ADD_PRODUCT")}</text>
                                    </div>}

                                    {!comment && <div className="button large secondary simple" data-length="forcefit" onClick={openCommentPopup}>
                                        <icon data-svg-size="20" data-svg-color="secondary"><SvgAddNote /></icon>
                                        <text data-width="auto">{t("ADD_QUOTE_NOTE")}</text>
                                    </div>}
                                </group>



                                {!network?._parameters.hidePrice && itemsList.length > 0 && <group dadata-length="forcefit" data-fit="1" data-gap="20" data-align="center">
                                    <text data-text-size="large" data-fit="2" data-length="autofit" data-weight="300">{t('TOTAL_HT', { currency: network?._parameters.currency })}</text>
                                    <text data-text-size="large" data-fit="1" data-length="autofit" data-text-align="center" data-weight="600">{numeral(getTotal(itemsList, false)).format('0,0.00')} {network?._parameters.currency}</text>
                                    <space data-length="10"></space>
                                </group>}


                                {comment && <group
                                    {...(isThermor ? { "data-border-color": "main-color-custom-border" } : { "data-color": "main-light" })}
                                    data-border="inheret"
                                    data-space-vertical="30"
                                    data-space-horizontal="100"
                                    data-radius="10"

                                >
                                    <group data-direction="column"
                                        data-contain=""
                                        data-background="white"
                                        data-color="initial"
                                    //data-gap="10"
                                    >

                                        <group data-length="forcefit" data-fit="1"
                                            //data-gap="10" 
                                            data-wrap="no" data-align="center">
                                            <text data-text-size="larger" data-weight="600">{t("MY_PERSONAL_NOTE")}</text>

                                            <div className="button large secondary simple" data-length="forcefit" onClick={openCommentPopup}>
                                                <icon data-svg-size="20" data-svg-color="secondary"><SvgCommandEdit /></icon>
                                                <text data-width="auto">{t("UPDATE")}</text>
                                            </div>

                                        </group>

                                        <group data-length="forcefit" data-fit="1" >
                                            <text data-text-size="large" data-wrap="preline" data-break="break-all">{comment}</text>
                                        </group>
                                    </group>

                                </group>}
                            </group>

                            <group data-gap="20" data-adaptive="mobile">
                                <group data-length="forcefit" data-fit="1" data-gap="20">
                                    {addProduct && <div className="button large secondary outline" data-length="forcefit" onClick={addProduct}>
                                        <icon data-svg-size="20" data-svg-color="secondary"><SvgCommandAdd /></icon>
                                        <text data-width="auto">{t("ADD_PRODUCT")}</text>
                                    </div>}
                                </group>

                                {!network?._parameters.hidePrice && itemsList.length > 0 && <group dadata-length="forcefit" data-fit="1" data-gap="20" data-align="center">
                                    <text data-text-size="large" data-fit="2" data-length="autofit" data-weight="300" data-text-align="right">{t('TOTAL_HT', { currency: network?._parameters.currency })}</text>
                                    <text data-text-size="large" data-fit="1" data-length="autofit" data-text-align="right" data-weight="600">{numeral(getTotal(itemsList, false)).format('0,0.00')} {network?._parameters.currency}</text>
                                    <space data-length="10"></space>
                                </group>}

                                <group data-length="forcefit" data-fit="1" data-gap="20">
                                    {!comment && <div className="button large secondary simple" data-length="forcefit" onClick={openCommentPopup}>
                                        <icon data-svg-size="20" data-svg-color="secondary"><SvgAddNote /></icon>
                                        <text data-width="auto">{t("ADD_QUOTE_NOTE")}</text>
                                    </div>}
                                </group>






                                {comment && <group data-color="main-light"
                                    data-border="inheret"
                                    data-space-vertical="10"
                                    data-space-horizontal="20"
                                    data-radius="10"

                                >
                                    <group data-direction="column"
                                        data-contain=""
                                        data-background="white"
                                        data-color="initial"
                                    //data-gap="10"
                                    >

                                        <group data-width="autofit"
                                            data-wrap="no"
                                            data-gap="10"
                                        >
                                            <div data-length="autofit">
                                                <text data-text-size="larger" data-weight="600" data-wrap="wrap" data-ellipsis="">{t("MY_PERSONAL_NOTE")}</text>
                                            </div>

                                            <div
                                                data-position="right"
                                                data-max-width="20"
                                                onClick={openCommentPopup}
                                                className="button micro"
                                            >
                                                <icon data-svg-size="20" data-svg-color="secondary"><SvgCommandEdit /></icon>
                                            </div>

                                        </group>

                                        <group data-width="autofit" >
                                            <text data-text-size="large" data-wrap="preline" data-break="break-all">{comment}</text>
                                        </group>
                                    </group>

                                </group>}
                            </group>
                        </>
                    }

                </group>



            </group>
        </>
    )
}

export default QuoteSection;